module.exports = __webpack_public_path__ + "static/media/chart-pie.0bf24682.svg";